import { AuditDevice } from "../models/AuditDevice";
import { AuditTrip } from "../models/AuditTrip";
import { isWithinEditWindow } from "@/utilities/trip/isWithinEditWindow";
import { TripRef } from "@/utilities/trip/TripRef";

/**
 * Why an entry cannot be assigned a driver or reason: it is an analog booking (the driver is the
 * roster record's user, the reason lives on the Geotab trips behind it), it ended before the edit
 * window of the "Access Logbook" group, or the vehicle's "Digitales Fahrtenbuch" check does not
 * read "Okay". Undefined when assignment is allowed.
 */
export type AssignmentBlocker = "analog" | "window" | "vehicleCheck";

export function assignmentBlocker(trip: AuditTrip, days: number, now: Date): AssignmentBlocker | undefined {
  if (trip.recordType !== "digital") return "analog";
  if (!isWithinEditWindow(trip, days, now)) return "window";
  if (trip.device.vehicleCheck.status !== "ok") return "vehicleCheck";
  return undefined;
}

/** The vehicles among the trips whose check does not read "Okay", each once, in order of appearance. */
export function blockedVehicles(trips: Pick<AuditTrip, "device">[]): AuditDevice[] {
  const seen = new Set<string>();
  const blocked: AuditDevice[] = [];
  for (const { device } of trips) {
    if (device.vehicleCheck.status === "ok" || seen.has(device.id)) continue;
    seen.add(device.id);
    blocked.push(device);
  }
  return blocked;
}

/** The part of a digital entry the logbook writers need: it is the Geotab trip's id, device and times. */
export function toTripRef(trip: AuditTrip): TripRef {
  return { id: trip.id, device: { id: trip.device.id }, start: trip.start, stop: trip.stop ?? trip.start };
}
